import { Avatar, Col, Divider, Row, Select, Space } from "antd";
import { storage } from "lib";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import useCompany from "features/company/hooks/useCompany";
import {
  setCurrentCompany,
  setCurrentEmployee,
} from "features/company/slices/companySlice";
import useConfig from "features/config/hooks/useConfig";
import { useTranslation } from "react-i18next";
import styles from "./Company.module.css";

function Company() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    companyList = [],
    currentEmployee = null,
    handleChange,
    getCompanyOptions,
    getRolePermissionByEmpId,
    getEmploymentInfoCallback
  } = useCompany();
  const { onThemeChange } = useConfig();
  const { roles } = useSelector((state) => state.company);

  const currentCompany = storage.localStorage.getItem("currentCompany");


  const onCreateCompany = useCallback(() => {
    navigate("/configuration/company/create");
  }, [navigate]);

  const onInit = useCallback(() => {
    console.log("onInit1");

    getCompanyOptions((data) => {
      console.log("onInit2.1", data);
      if (currentCompany) {
        const foundCompany = data.find((c) => c.companyId === currentCompany);
        if (foundCompany) {
          dispatch(setCurrentCompany(foundCompany.value));
          dispatch(setCurrentEmployee(foundCompany.employeeId));
          storage.localStorage.setItem("currentCompany", foundCompany.value);
          storage.localStorage.setItem("currentEmployee", foundCompany.employeeId);
          onThemeChange(foundCompany);
          return;
        }
      }
      console.log("onInit2", data);

      const firstCompany = data[0] || null;
      if (firstCompany) {
        dispatch(setCurrentCompany(firstCompany.value));
        dispatch(setCurrentEmployee(firstCompany.employeeId));
        storage.localStorage.setItem("currentCompany", firstCompany.value);
        storage.localStorage.setItem("currentEmployee", firstCompany.employeeId);
        onThemeChange(firstCompany);
      }
    });
  }, [getCompanyOptions, onThemeChange, dispatch]);

  useEffect(() => {
    onInit();
  }, [onInit]);


  useEffect(() => {
    // console.log("eff", currentEmployee);
    if (currentEmployee) {
      getRolePermissionByEmpId();
      getEmploymentInfoCallback()
    }
  }, [currentEmployee])


  function srcImg() {
    let temp = companyList?.find?.(o => o.companyId === currentCompany)?.companyLogo

    return temp ? "data:image/png;base64, " + temp
      : ""
  }
  return (
    <Row
      className={styles.companyContainer}
      justify="space-between"
      align="middle"
    >
      <Col>
        <Space size={16}>
          <Avatar size={32}
            src={srcImg()}
          />
          <Select
            variant={false}
            className={styles.company}
            value={currentCompany}
            size="large"
            onChange={((e) => {
              navigate("/");
              handleChange(e)
            }
            )}
            options={companyList}
            dropdownRender={(menu) => (
              <>
                {menu}
                <Divider
                  style={{
                    margin: "8px 0",
                  }}
                />
                {roles.includes("ACCESS_CREATE_COMPANY") &&
                  <Space
                    style={{
                      padding: "0 8px 4px",
                    }}
                  >
                    <div className={styles.create} onClick={onCreateCompany}>
                      <span>{t("company_setting.label.create")}</span>
                    </div>
                  </Space>
                }
              </>
            )}
          />
        </Space>
      </Col>
    </Row>
  );
}

export default Company;
